import { Component } from '@angular/core';
import { I18n } from '@app/i18n/strings-keys';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-no-content',
  template: `
    <div>
      <h1>{{ I18n.ErrorMessages.Page404 | translate }}</h1>
    </div>
  `,
})
export class NoContentComponent {
  public I18n = I18n;
}
